import React, { useEffect } from 'react';
import { FaSun } from 'react-icons/fa';
import { CURRENCY_MAP_ICON } from '../../widgets/SearchTourForm/constants/CurrencyClasses';

const SearchDropdownCountryList = (props) => {
  function getCountryFlag(countryId) {
    return `https://www.geograftour.com/static/index/img/flags/${countryId.toUpperCase()}.svg`;
  }
  
  const emptyString = { name: 'Ничего не найдено', id: 1000 };

  return (
    <div className="popup-body fixed countries-list">
      {props.items.length
        ? props.items.map((item) => {
            return renderCountryItem(item, getCountryFlag(item.code), props);
          })
        : renderCountryItem(emptyString, 1, 0)}
    </div>
  );
};

const renderCountryItem = (item, flag_src, props) => {
  const isSelected = item.id === props.value;

  return (
    <p
      key={item.id}
      title={item.id}
      className={`clickable country-container ${isSelected ? 'country-container_selected' : ''}`}
      onClick={() => props.onChoose(item.id)}
    >
      {item.code && (
        <img alt={item.name} className="country-flag" src={flag_src} />
      )}
      {item.name}
      {item.visa ? <span className="country-visa">Виза</span> : <span></span>}
      {item.tempair ? (
        <span className="country-weather">
          <FaSun /> +{item.tempair}
        </span>
      ) : null}
      {item.price ? (
        <span className="country-price">
          от {item.price} <b>{CURRENCY_MAP_ICON[item.currency]}</b>
        </span>
      ) : null}
    </p>
  );
};

export default SearchDropdownCountryList;
